(function($) {
  if (!!$('.js-hos').offset()) {
    var stickyTop = $('.js-hos').offset().top;
    $(window).scroll(function(){
    var windowTop = $(window).scrollTop();
    if (stickyTop < windowTop){
    $('.js-block-header').addClass( 'fixed' );
    }
    else {
     $('.js-block-header').removeClass( 'fixed' );
    }
    });
  }
  $('.js-desktop-menu').click(function(){
    $(this).parent().toggleClass('active');
    $('.js-block-header').toggleClass('expanded');
  });

  $('.owl-news').owlCarousel({
      loop:false,
      autoplay: true,
      nav:true,
      dots: false,
      margin:0,
      items: 2,
      smartSpeed: 800,
      responsiveClass:true,
      autoplayHoverPause:true,
      navText: ['<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 477.175 477.175" xml:space="preserve" width="512px" height="512px"><g><path d="M145.188,238.575l215.5-215.5c5.3-5.3,5.3-13.8,0-19.1s-13.8-5.3-19.1,0l-225.1,225.1c-5.3,5.3-5.3,13.8,0,19.1l225.1,225   c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1L145.188,238.575z" fill="#ffffff"/></g></svg>','<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 477.175 477.175" xml:space="preserve" width="512px" height="512px"><g><path d="M360.731,229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1,0s-5.3,13.8,0,19.1l215.5,215.5l-215.5,215.5   c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4c3.4,0,6.9-1.3,9.5-4l225.1-225.1C365.931,242.875,365.931,234.275,360.731,229.075z   " fill="#ffffff"/></g></svg>'],
      responsive:{
        0:{
            items:1
        },
        1200:{
            items:2
        }
    }
  });
  $('.owl-related').owlCarousel({
      loop:true,
      autoplay: true,
      nav:true,
      dots: false,
      margin:20,
      items: 4,
      smartSpeed: 800,
      responsiveClass:true,
      autoplayHoverPause:true,
      navText: ['<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 477.175 477.175" xml:space="preserve" width="512px" height="512px"><g><path d="M145.188,238.575l215.5-215.5c5.3-5.3,5.3-13.8,0-19.1s-13.8-5.3-19.1,0l-225.1,225.1c-5.3,5.3-5.3,13.8,0,19.1l225.1,225   c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1L145.188,238.575z" fill="#000"/></g></svg>','<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 477.175 477.175" xml:space="preserve" width="512px" height="512px"><g><path d="M360.731,229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1,0s-5.3,13.8,0,19.1l215.5,215.5l-215.5,215.5   c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4c3.4,0,6.9-1.3,9.5-4l225.1-225.1C365.931,242.875,365.931,234.275,360.731,229.075z   " fill="#000"/></g></svg>'],
      responsive:{
        0:{
            items:1
        },
        400:{
            items:2
        },
        800:{
            items:3
        },
        1000:{
            items:4
        }
    }
  });

  $(document).ready(function () {
    if(window.location.pathname === '/challenge'){
      $('.js-block-header').addClass('new-header-inner');
    }
    $('[data-fancybox="images"]').fancybox();

    if($(window).width() < 1200){
      $('.order_summary').each(function(){
        $(this).find('td').eq(0).attr('colspan', 0);
        $(this).find('td').eq(1).attr('colspan', 4);
      });
    }

    var mySwiper1 = new Swiper ('.swiper-banner', {
       speed: 1200,
       parallax: true,
       loop: true,
       autoplay: {
            delay: 5000,
            pauseOnMouseEnter: true,
            disableOnInteraction: true,
          },
        navigation: {
          nextEl: '.banner-next',
          prevEl: '.banner-prev',
        },
    });
    $('.swiper-banner').on('mouseenter', function(e){
      mySwiper1.autoplay.stop();
    });
    $('.swiper-banner').on('mouseleave', function(e){
      mySwiper1.autoplay.start();
    });
    var mySwiper2 = new Swiper ('.swiper-featured', {
       speed: 1500,
       parallax: true,
       loop: true,
       autoHeight: true,
       autoplay: {
            delay: 5000,
            pauseOnMouseEnter: true,
            disableOnInteraction: false,
          },
      navigation: {
        nextEl: '.featured-next',
        prevEl: '.featured-prev',
      },
    });
    mySwiper2.on('slideChange', function (swiper) {
      $('.featured-numbers li').removeClass('active');
      $('.featured-numbers .number-'+(mySwiper2.realIndex+1)).addClass('active');
    });
    $('.swiper-featured').on('mouseenter', function(e){
      mySwiper2.autoplay.stop();
    });
    $('.swiper-featured').on('mouseleave', function(e){
      mySwiper2.autoplay.start();
    });

    if ($('[data-productThumb]').length) {
      $('[data-productThumb]').slick({
        dots: false,
        arrows: true,
        infinite: false,
        vertical: true,
        verticalSwiping: true,
        slidesToShow: 3,
        slidesToScroll: 1
     });
    }

    $('#switch-select').on('change', function(){
      var vl = $(this).val();
      $('#switch-input').attr('data-input', vl);
    });
    $('.js-selectpicker').selectpicker();
  });
  $(window).on('resize', function(){
    if($(window).width() < 1200){
      $('.order_summary').each(function(){
        $(this).find('td').eq(0).attr('colspan', 0);
        $(this).find('td').eq(1).attr('colspan', 4);
      });
    }
  });
  $('.js-selectpicker').on('changed.bs.select', function (e, clickedIndex, isSelected, previousValue) {
    console.log($('select[data-product-master-select]').find(':selected').data('price'));
    console.log($('select[data-product-master-select]').find(':selected').data('imgurl'));
    $('.js-variants .product-price').html($('select[data-product-master-select]').find(':selected').data('price'));
    $('#proimage').attr('src', $('select[data-product-master-select]').find(':selected').data('imgurl'));
    var value = $(this).val();
    $(this).closest('.js-variants').find('[type="radio"][data-value="'+value+'"]').trigger('click');
  });
  $('.js-variants .width input[type="radio"]').on('change', function(){
    var value = $(this).val();
    $(this).closest('.js-variants').find('.select-block.width select').val(value).trigger('change');
  });
  $('.js-variants .size input[type="radio"]').on('change', function(){
    var value = $(this).val();
    $(this).closest('.js-variants').find('.select-block.size select').val(value).trigger('change');
  });
  $('.js-variants .color input[type="radio"]').on('change', function(){
    var value = $(this).val();
    $(this).closest('.js-variants').find('.select-block.color select').val(value).trigger('change');
  });

 
  

  $('.js-menu').click(function(e) {
    e.preventDefault();
    $(this).parent().toggleClass('active');
    $('.js-block-header').toggleClass('expanded');
    $('body').toggleClass('open-modal');
    $('.block-mobile-nav, .block-wrapper, .block-header').toggleClass(
      'active');
  });
  $('.js-mobile-menu li i').click(function(e) {
    e.preventDefault();
    $(this).parent().toggleClass('active');
    $(this).next().slideToggle();
  });
  $('.block-nav button').click(function(){
    $(this).toggleClass('active');
    $(this).next().slideToggle();
  });
  $('.js-eye').click(function(e){
    var ths = $(this);
    ths.toggleClass('active');
    ths.next().attr('type', ths.next().attr('type') == 'password' ? 'text' : 'password');
  });
  $('[data-productZoom] img').click(function(){
    var image = $(this).attr('data-image');
    $('[data-productZoom] .slick-current').removeClass('slick-current');
    $(this).parent().addClass('slick-current');
    $('#proimage').attr('src', image);
  });
  $('a[href*="#"]:not([href="#"])').click(function() {
    if($(this).parent().parent().attr('id')=='myTab'){
        return
    }
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        $('html,body').animate({
          scrollTop: target.offset().top
        }, 1000);
        return false;
      }
    }
  });

  $('.qty-btn').click(function() {
    var iQty = $(this).closest('[data-quantity').find('input');
    var cQty = iQty.val();
    if ($(this).hasClass("plus")) {
      iQty.val(cQty - 0 + 1);
    }
    if ($(this).hasClass("minus")) {
      if (cQty > 1){
        iQty.val(cQty - 1);
      }
    }
  });

  $('[data-notice-close]').click(function(){
    $('body').removeClass('open-notice');
    $('[data-notice]').remove();
  });


})(jQuery);



